import { ArdoqId } from '@ardoq/api-types';
import type { EnhancedScopeData } from '@ardoq/data-model';

export const hasChildren = (
  componentId: ArdoqId,
  enhancedScopeData: EnhancedScopeData
) => {
  const component = enhancedScopeData.componentsById[componentId];
  return (
    enhancedScopeData.hierarchy
      .get(component.rootWorkspace)
      ?.has(componentId) ?? false
  );
};
